// Speed Points, Power Points
export function generateKDiagramResultScatterSeries(data, name, pointFormat = null) {
  return {
    name: name,
    color: "var(--kdiagram-power-prediction-points-color)",
    type: "scatter",
    data: data,
    marker: {
      radius: 3.5,
      symbol: "circle",
      states: {
        hover: {
          enabled: true,
          lineColor: "var(--kdiagram-power-prediction-points-color)"
        }
      }
    },
    fillOpacity: "0.7",
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    jitter: {
      x: 0.005
    },
    tooltip: {
      pointFormat: pointFormat
    }
  };
}
